import React, { FunctionComponent, useCallback, useState } from 'react';
import { Button, Card, Dropdown, Form, Icon } from 'semantic-ui-react';
import {
  getSeasonalToastTheme,
  ToastError,
  ToastInfo,
  ToastSuccess,
  ToastTheme,
  ToastWarn,
} from 'utils';

const themeOptions: { key: ToastTheme; value: ToastTheme; text: string }[] = [
  { key: 'regular', value: 'regular', text: 'Normal' },
  { key: 'halloween', value: 'halloween', text: 'Halloween' },
  { key: 'christmas', value: 'christmas', text: 'Noël' },
];

const toastPreviews = {
  info: (className: string): void =>
    ToastInfo('Info', 'Exemple de notification d’information', { className }),
  success: (className: string): void =>
    ToastSuccess('Succès', 'Exemple de notification de succès', { className }),
  warning: (className: string): void =>
    ToastWarn('Attention', 'Exemple de notification d’avertissement', {
      className,
    }),
  error: (className: string): void =>
    ToastError('Erreur', 'Exemple de notification d’erreur', { className }),
};

type ToastPreviewType = keyof typeof toastPreviews | 'all';

const typeOptions: {
  key: ToastPreviewType;
  value: ToastPreviewType;
  text: string;
}[] = [
  { key: 'all', value: 'all', text: 'Tous' },
  { key: 'info', value: 'info', text: 'Info' },
  { key: 'success', value: 'success', text: 'Succès' },
  { key: 'warning', value: 'warning', text: 'Avertissement' },
  { key: 'error', value: 'error', text: 'Erreur' },
];

export const ToastsPreviewCard: FunctionComponent = () => {
  const [theme, setTheme] = useState<ToastTheme>(getSeasonalToastTheme());
  const [type, setType] = useState<ToastPreviewType>('all');

  const onClickPreview = useCallback((): void => {
    const types =
      type === 'all'
        ? (Object.keys(toastPreviews) as (keyof typeof toastPreviews)[])
        : [type];
    types.forEach((previewType) => toastPreviews[previewType](theme));
  }, [theme, type]);

  return (
    <Card>
      <Card.Content>
        <Icon size="large" style={{ float: 'right' }} name="bell" />
        <Card.Header>Notifications</Card.Header>
        <Card.Description>
          Afficher un exemple de notification
          <Form style={{ marginTop: '1em' }}>
            <Form.Field>
              <label>Thème</label>
              <Dropdown
                selection
                fluid
                options={themeOptions}
                value={theme}
                onChange={(_, { value }): void => setTheme(value as ToastTheme)}
              />
            </Form.Field>
            <Form.Field>
              <label>Type</label>
              <Dropdown
                selection
                fluid
                options={typeOptions}
                value={type}
                onChange={(_, { value }): void =>
                  setType(value as ToastPreviewType)
                }
              />
            </Form.Field>
          </Form>
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <Button fluid primary onClick={onClickPreview}>
          Exécuter
        </Button>
      </Card.Content>
    </Card>
  );
};
